import styled from 'styled-components';

export const PersonName = styled.span`
  word-break: break-word;
  hyphens: auto;
`;
